// src/modules/app-views/services/pages/Document/decorators/request.js
// *******************************************************************************
// REQUEST DECORATOR
// Transforms data before sending to the server
// *******************************************************************************

/**
 * Transforms form data before sending to the server
 *
 * @param {Object} ctx - Context object
 * @param {Object} ctx.data - Form data to be sent (changed fields only)
 * @param {Object} ctx.allValues - Complete form data with original values
 * @param {String} ctx.url - Request URL
 * @param {String} ctx.method - HTTP method
 * @returns {Object} Transformed data ready for backend
 */
const decorateRequest = ctx => {
  const { data, allValues } = ctx;

  if (!data) return data;

  // Clone data to avoid mutations
  const transformed = { ...data };

  // ───────────────────────────────────────────────────────────────────────────
  // ATTACHMENTS TRANSFORMATION
  // Transform attachment objects (avatar, etc.) back to their format
  // ───────────────────────────────────────────────────────────────────────────
  const attachmentTypes = [
    'avatar',
    'logo',
    'cover',
    'gallery',
    'document',
    'contract',
    'qrcode',
    'signature',
    'other',
  ];

  attachmentTypes.forEach(attachType => {
    if (data[attachType] && typeof data[attachType] === 'object') {
      // Get original attachment from attachments array (has _id, etc)
      const originalAttachment = allValues?.attachments?.find(
        a => a.attachmentType === attachType
      );

      const attachObj = { ...data[attachType] };
      if (attachObj.id && !attachObj.attachmentId) {
        attachObj.attachmentId = attachObj.id;
        delete attachObj.id;
      }

      transformed[attachType] = {
        ...attachObj,
        _id: originalAttachment?._id,
      };
    }
  });

  return transformed;
};

export default decorateRequest;
